import React, { useMemo } from 'react';
import { Form, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { countries } from './countries';
import { makeKey } from '@rd-web-markets/shared/dist/hooks/useConvertForTranslationKey';
import { normalizeForSort } from '@rd-web-markets/shared/dist/util/stringUtils';
const CountrySelect = _ref => {
  let {
    value,
    onChange,
    disabled,
    name = 'country'
  } = _ref;
  const {
    t
  } = useTranslation();
  const sortedCountries = useMemo(() => {
    return countries.map(country => ({
      value: country,
      label: t(makeKey(country))
    })).sort((a, b) => {
      const left = normalizeForSort(a.label);
      const right = normalizeForSort(b.label);
      if (left < right) return -1;
      if (left > right) return 1;
      return 0;
    });
  }, [t]);
  return /*#__PURE__*/React.createElement(Form.Group, {
    as: Col,
    className: "col-md-4"
  }, /*#__PURE__*/React.createElement(Form.Label, null, t('country'), "*"), /*#__PURE__*/React.createElement(Form.Control, {
    as: "select",
    name: name,
    onChange: onChange,
    size: "md",
    value: value !== null && value !== void 0 ? value : '',
    disabled: disabled
  }, /*#__PURE__*/React.createElement("option", {
    value: null
  }), sortedCountries.map(_ref2 => {
    let {
      value: countryValue,
      label
    } = _ref2;
    return /*#__PURE__*/React.createElement("option", {
      key: countryValue,
      value: countryValue
    }, label);
  })));
};
export default CountrySelect;